import React, { useEffect, useState } from 'react'
import ReactDOM  from 'react-dom'
import PropTypes from 'prop-types'

let PaypalElement = null

/**
 * ButtonPaypal component.
 */
export const ButtonPaypal = ({ brainTreeInstancesGet, brainTreeIsInstantiated, orderUpdate, onSetError, onSetProcessing, paymentHasCompleted, values, onPaymentSelect, donationFeeRate }) => {
  const [ready, readySet] = useState(false)

  /**
   * Render the PayPal button.
   */
  const renderButton = () => {
    const totalPrice = (donationFeeRate && values.cover_donation_fee === 'Y')
    ? (parseFloat(values.payment_amount) * donationFeeRate).toFixed(2).replace('.00', '')
    : values.payment_amount;

    const paypalCreateOrder = () => {
      return brainTreeInstancesGet().paypalCheckoutInstance.createPayment({
        flow    : 'checkout',
        amount  : totalPrice,
        currency: 'GBP',
        intent  : 'capture',
      })
    }

    /**
     * Handle the Paypal approve event.
     *
     * @param {{}} data
     *   The data object.
     * @returns {Promise}
     *   Returns a promise that the action will complete.
     */
    const paypalOnApprove = data => {
      onSetProcessing(true)
      const brainTreeInstances = brainTreeInstancesGet()
      return brainTreeInstances.paypalCheckoutInstance.tokenizePayment(data, (err, payload) => {
        onPaymentSelect(true)
        orderUpdate({
          first_name         : payload.details['firstName'],
          last_name          : payload.details['lastName'],
          email_address      : payload.details.email,
          payment_client_data: brainTreeInstances.dataCollector['deviceData'],
          payment_nonce      : payload.nonce,
          payment_provider   : 'Paypal',
          payment_method     : payload.type,
        })
      })
    }

    /**
     * Handle the cancel event.
     */
    const paypalOnCancel = () => {
      onSetProcessing(false)
    }

    /**
     * Handle the payment error.
     *
     * @param err
     *   The error response.
     */
    const paypalOnError = err => {
      console.error('PayPal error', err)
      onSetError(err)
    }

    return (
      <PaypalElement
        fundingSource={paypal.FUNDING.PAYPAL}
        style={{
          shape : 'pill',
          height: 49,
          label : 'pay'
        }}
        createOrder={paypalCreateOrder}
        onApprove={paypalOnApprove}
        onCancel={paypalOnCancel}
        onError={paypalOnError}
      />
    )
  }

  useEffect(() => {
    if (brainTreeIsInstantiated) {
      brainTreeInstancesGet().paypalCheckoutInstance.loadPayPalSDK(
        {
          currency: 'GBP',
          intent  : 'capture'
        })
        .then(() => {
          PaypalElement = paypal.Buttons.driver("react", { React, ReactDOM })
          readySet(true)
        })
    }
  }, [brainTreeIsInstantiated])

  return (
    <React.Fragment>
      {ready && !paymentHasCompleted && renderButton()}
    </React.Fragment>
  )
}

/**
 * ButtonPaypal PropTypes.
 */
ButtonPaypal.propTypes = {
  brainTreeIsInstantiated: PropTypes.bool,
  brainTreeInstancesGet  : PropTypes.func,
  paymentHasCompleted    : PropTypes.bool,
  onSetProcessing        : PropTypes.func,
  onSetError             : PropTypes.func,
  orderUpdate            : PropTypes.func,
  values: PropTypes.shape({
    payment_amount: PropTypes.string,
    cover_donation_fee: PropTypes.string,
  }),
  onPaymentSelect        : PropTypes.func,
  donationFeeRate        : PropTypes.number
}
